(function () {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('RelatorioConcursoCorregedoria', RelatorioConcursoCorregedoria);

  function RelatorioConcursoCorregedoria(RelatorioConcursoService, FileSaver, Blob,
    ngsalConfig, $scope, toaster, i18n, blockUI, PromotorService, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.adicionarPromotor = adicionarPromotor;
    vm.removerPromotor = removerPromotor;
    vm.exportarExcel = exportarExcel;
    vm.subirPosicao = subirPosicao;
    vm.descerPosicao = descerPosicao;
    vm.exibeBotaoAdicionar = exibeBotaoAdicionar;
    vm.consultarPromotor = consultarPromotor;

    vm.init();

    function init() {
      vm.versionApi = ngsalConfig.apiVersion;
      vm.promotoresList = [];
      vm.permiteExportacao = false;
      vm.quantidadeMaxima = {
        quantidade: CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO
      };
    }

    function consultarPromotor(query, timeoutPromise) {
      return PromotorService.consultarPromotor(query, timeoutPromise, true);
    }

    function adicionarPromotor() {

      vm.permiteExportacao = true;

      if (vm.promotoresList.length < CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO) {
        vm.promotoresList.push(vm.promotorSelecionado.originalObject);
      }

      $scope.$broadcast('angucomplete-alt:clearInput');
    }

    function exibeBotaoAdicionar() {
      return vm.promotoresList.length < CONSTANTS.QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO;
    }

    function removerPromotor(idx) {
      vm.promotoresList.splice(idx, 1);

      if(vm.promotoresList.length === 0 ) {
        vm.permiteExportacao = false;
      } else {
        vm.permiteExportacao = true;
      }
    }

    function subirPosicao(idx) {
      if (idx > 0) {
        var temp = vm.promotoresList[idx-1];
        vm.promotoresList[idx-1] = vm.promotoresList[idx];
        vm.promotoresList[idx] = temp;
      }
    }

    function descerPosicao(idx) {
      if (idx !== vm.promotoresList.length - 1) {
        var temp = vm.promotoresList[idx + 1];
        vm.promotoresList[idx+1] = vm.promotoresList[idx];
        vm.promotoresList[idx] = temp;
      }
    }

    function exportarExcel() {
      blockUI.start();
      RelatorioConcursoService.exportarExcel(vm.promotoresList)
      .then(function(data) {
        if (data !== null && data.size === 0) {
          toaster.pop("warning",i18n.translate("corregedoria.relatorio.concurso.titulo"),
          i18n.translate("relatorio.sem.dados"));
        } else {
          var blob = new Blob([data], {type: 'application/vnd.ms-excel'});
          FileSaver.saveAs(blob, 'relatorio-concurso.xlsx');
        }
      }).finally(function(){
        blockUI.stop();
      });
    }
  }

})();
